module.exports = __webpack_public_path__ + "static/media/t.d3a60298.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/t.mp3
// module id = 109
// module chunks = 0